export default __webpack_public_path__ + "static/media/5.762febb8.png";